import { render, staticRenderFns } from "./TransactionDetailLogo.vue?vue&type=template&id=1e069718&"
import script from "./TransactionDetailLogo.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailLogo.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports